<section class="faq-section py-5">
  <div class="container">
    <div class="row text-center section-header-row">
      <div class="col-12">
        <h2 class="section-title">Frequently Asked Questions</h2>
        <p class="section-subtitle">Answers to common questions about setup, imports, security, and support.</p>
      </div>
    </div>
    
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <mat-accordion class="faq-accordion">
          <mat-expansion-panel *ngFor="let faq of faqs" class="faq-panel">
            <mat-expansion-panel-header class="faq-header">
              <div class="faq-question">
                <mat-icon class="faq-icon me-3">{{ faq.icon }}</mat-icon>
                <span>{{ faq.question }}</span>
              </div>
            </mat-expansion-panel-header>
            <div class="faq-answer">
              {{ faq.answer }}
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
    
    <div class="row mt-5">
      <div class="col-12 text-center">
        <div class="cta-section">
          <p class="cta-text mb-3">Still have questions?</p>
          <a mat-flat-button color="primary" class="me-3" routerLink="/contact">Contact Support</a>
          <a mat-stroked-button color="primary" href="https://docs.membertrace.com" target="_blank" rel="noopener">View Documentation</a>
        </div>
      </div>
    </div>
  </div>
</section>
